package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.Membership
import com.rainbowclubs.rainbow.data.requests.UpdateMembershipRequest
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class UpdateMembershipUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(
        membershipId: String,
        request: UpdateMembershipRequest,
    ): Result<Membership> {
        return membershipRepository.updateMembership(membershipId, request)
    }
}
